import { useLayoutEffect, useEffect, useRef } from 'react';
var Effect = typeof window === 'undefined' ? useEffect : useLayoutEffect;
export function useCombineRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  var ref = useRef(null);
  Effect(function () {
    refs.forEach(function (item) {
      if (item == null) {
        return;
      }

      if (typeof item === 'function') {
        item(ref.current);
      } else {
        Object.assign(item, {
          current: ref.current
        });
      }
    });
  });
  return ref;
}